import { Component, OnInit, Input, Injectable, ChangeDetectorRef } from '@angular/core';
import { ApplicationService } from 'app/services/application.service';
import { StatusService } from 'app/services/status.service';
import { AuthWebService } from 'app/services/authweb.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, Params, RouteConfigLoadStart } from '@angular/router';
import { VehicleEntryService } from 'app/services/vehicle-entry.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CountryService } from 'app/services/country.service';
import { VehicleMakeService } from 'app/services/vehicle-make.service';
import { VehicleTypeService } from 'app/services/vehicle-type.service';
import { environment } from '../../../../src/environments/environment';
import { NgbCalendar, NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct, NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

import { VehicleService } from 'app/services/vehicle.service';
import { Location, DatePipe } from '@angular/common';
import { PermitTypeService } from 'app/services/permit-type.service';
import { VehicleEntryCarrierService } from 'app/services/vehicle-entry-carrier.service';
import { PopupService } from 'app/services/shared/popup.service';
import { Baseservice } from 'app/services/baseservice';
import { DocumenttypeService } from 'app/services/documenttype.service';
import { DocumentsServiceService } from 'app/services/documents-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ReturnStatement } from '@angular/compiler';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import { debug } from 'console';

/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '/';
  
  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10)
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DT_FORMAT = 'DD/MM/YYYY';

  parse(value: string): NgbDateStruct {
    if (value) {
      value = value.trim();
      let mdt = moment(value, this.DT_FORMAT)
    }
    return null;
  }
  format(date: NgbDateStruct): string {
    if (!date) return '';
    let mdt = moment([date.year, date.month - 1, date.day]);
    if (!mdt.isValid()) return '';
    return mdt.format(this.DT_FORMAT);
  }
}




declare var $;
@Component({
  selector: 'app-manage-vehicles',
  templateUrl: './manage-vehicles.component.html',
  styleUrls: ['./manage-vehicles.component.css'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    NgbActiveModal,
  ]
})
export class ManageVehiclesComponent implements OnInit {
  @Input('ctrlData') ctrlData: any;
  permits: any = [];
  currentDate = { day: new Date().getDate(), month: (new Date().getMonth() + 1), year: new Date().getFullYear() }
  statuses: any = [];
  flags = { flagAN: 1, flagNM: 1, flagLU: 1, flagCT: 1, flagAP: 1, flagPT: 1, flagST: 1, flagDS: 1 };
  ranks = { flagAN: 1, flagNM: 2, flagLU: 3, flagCT: 4, flagAP: 5, flagPT: 6, flagST: 7, flagDS: 8 };
  sortLabels = { flagAN: "AccountNumber", flagNM: "Name", flagLU: "LeadUser", flagCT: "CarrierType", flagAP: "ApplicationNumber", flagPT: "PermitType", flagST: "Status", flagDS: "DateSubmitted" };
  direction: boolean = false;
  criteria = "DateSubmitted";
  rankCtrl: number = 8;
  isLoading: Boolean = false;
  message: string = 'Loading  vehicles, please wait...';
  statuses1: any = [];

  //Search Variables
  eNatisCounter = 0;
  vehicletypes: any = [];
  permittypes: any = [];
  vinnumber: string;
  vehicleType: string = "";
  permitType: string = "";
  regnumber: string;
  carriername: string;
  carriercode: string;
  found = false;
  keyword: any = {};
  currentPage = 1;
  isEmpty: boolean = false;
  IsSearching: boolean = false;
  IsAdmin: boolean = false;
  pageSize: number = 1000;
  page: any = 1;
  count: number = 0;
  disabled = false;
  ShowFilter = false;
  limitSelection = false;
  selectedItems: any = [];
  dropdownSettings: any = {};
  registerNumber: string;
  isDef: boolean = true;
  vehicleRes: any = [];
  isEditData: boolean = false;
  isViewData:boolean=false;
  myForm: UntypedFormGroup;
  ddlCountries: any = [];
  list_vehicle_make: any = [];
  list_vehicle_type: any = [];
  list_vehicle_types: any = [];
  selectedVMake: any;
  btnAddNew: boolean;
  leased: any;
  appid: any = null;
  @Input() dataCntrl: any;
  isMyVehicles = false;
  permit_type_id: any;
  isSame = false;
  myAppVehicles = [];
  license_expiry_date_global: any;

  model: NgbDateStruct;
  date: { year: number };
  selectedVehicles: any = [];
  selectedCountry: any = null;


  carrierId: any;
  isVehicleLoading: boolean = false;
  isDocumentLoading: boolean = false;
  uploadedDocs: any = [];
  maxMB: any = "5MB";
  dtype: any = "PDF,JPG,PNG,JPEG";
  docTypeId: any;
  filebytes: string;
  filename: any;
  filetype: any;
  filedescription: string;
  filesize: any;
  user = { LastName: '' };
  vehicleId: number;
  documentType: any;
  isLoadingImg: boolean;
  selectItem: any;
  viewDocuments: any = [];
  pdfSrc: any;
  img: any;

  linkedDocs: any;
  isExtra: boolean;
  eNatisResult: any = null;

  isReplacement: boolean = false;
  vehiclesReplacement: any = [];
  vehiclesReplace: any = [];
  isSouthAfrica = false;
  disallowEdit = false;
  currentVehicle: any = [];
  classMessage: string;
  wrongClass: boolean;
  curr_permit_type_id: number;

  constructor(private toastr: ToastrService,
    private vehicleEntryService: VehicleEntryService, private countryService: CountryService, private vehicleMakeService: VehicleMakeService,
    private authWebService: AuthWebService, private vehicleTypeService: VehicleTypeService, private permitTypeService: PermitTypeService,
    public utility: UtilityServiceService, private ngbCalendar: NgbCalendar, private dateAdapter: NgbDateAdapter<string>,
    private router: Router, private activeRoute: ActivatedRoute, private vehicleService: VehicleService,
    private _location: Location, private formBuilder: UntypedFormBuilder, private datePipe: DatePipe,
    private applicationService: ApplicationService, private vehicleEntryCarierService: VehicleEntryCarrierService, private msgService: PopupService,
    private documenttypeSerivce: DocumenttypeService, private documentService: DocumentsServiceService,
    private ref: ChangeDetectorRef, private sanitizer: DomSanitizer, private showModal: PopupService,private confirmDialogService: ConfirmDialogService,
  ) {
    this.activeRoute.params.subscribe((params: Params) => {
      this.appid = params['appid'];
      this.getApp(params['appid'])
      // this.getPermitsAppVecleEntry(params['appid']);

    });//vehicle-replace
    if (this.router.url.indexOf('vehicle-replace') > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.appid = params['appid'];
        this.getApp(params['appid']);
        // this.getPermitsAppVecleEntry(params['appid']);
      });
      this.isReplacement = true;

    }
  }

  ngOnInit() {    
    
    if (environment.authWebApi.systemData != null && environment.authWebApi.systemData.Configurations != null) {
      this.maxMB = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'MaxUploadMB1').Value;
      this.dtype = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'UploadDocTypes1').Value;
    }
    this.initKeyword();
     this.listCountries();
    this.getVehicleMake();
    this.getVehicles();
    this.createForm();
    this.loadvehicletypes();
    this.getPermitTypes();

    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
  }

  createForm() {
    this.isEditData = false;
    this.isViewData = false;
    this.isSouthAfrica = false;
    this.myForm = this.formBuilder.group({
      id: [-1, []],
      permit_id: [],
      country_id: ['', [Validators.required]],
      registration_number: ['', [Validators.required]],
      registration_year: ['', [Validators.required]],
      vehicle_make_id: ['', []],
      vehicle_series: ['', []],
      vehicle_model: ['', []],
      vehicle_colour: ['', []],
      vin: ['', [Validators.required,]],
      engine_number: ['', [Validators.required,]],
      gvn: ['', [Validators.required,]],
      seating_capacity: ['', []],
      date_license_expiry: ['', [Validators.required,]],
      start_date: ['', [Validators.required,]],
      vehicle_state: ['', []],
      roadworthy_status: ['', [Validators.required,]],
      vehicle_owner: ['', []],
      is_leased: [null, [Validators.required,]],
      vehicle_lessor: [''],
      vehicle_lessee: [''],
      date_lease_expiry: [''],
      vehicle_type_id: ['', [Validators.required]],
      api_date_updated: ['', []],
      eNatis_num: ['', []]
    });
    this.LeaseChange();    // hides the lease container
    this.found = false;    // hides the 'Retrieve from eNatis' button
    this.disallowEdit = false; // allow fields to be edited
    this.myForm.controls.country_id.enable();
    this.myForm.controls.roadworthy_status.enable();
    this.myForm.controls.vehicle_type_id.enable();
    this.myForm.controls.is_leased.enable();
  }

  passForEdit(item) {
    //console.log(item);
    this.isEditData = true;
    this.vehicleService.getVehicleBy(item.id).subscribe((x:any) => {
      //console.log(x);
      this.leased = x.is_leased;
      if(item.country_id='undefined' && !item.country_id){
        item.country_id = x.country_id;
      }
      if(item.roadworthy_status ='undefined' && !item.roadworthy_status){
        item.roadworthy_status = x.roadworthy_status;
      }
      if(item.vehicle_type_id ='undefined' && !item.vehicle_type_id){
        item.vehicle_type_id = x.vehicle_type_id;
      }
      if(item.is_leased ='undefined' && !item.is_leased){
        item.is_leased = x.is_leased;
      }
      debugger;
      if(item.date_license_expiry == this.license_expiry_date_global){
        this.isEditData = false;
        return;
      }
      this.myForm.patchValue({
        id: item.id,
        date_license_expiry: item.date_license_expiry,
        gvn: item.gvn,
        registration_number: item.registration_number,
        registration_year: item.registration_year,
        seating_capacity: x.seating_capacity,
        start_date: item.start_date,
        vehicle_make_id: item.vehicle_make_id,
        vehicle_type_id: item.vehicle_type_id,
        vin: item.vin,
        permit_id: x.permit_id,
        country_id: x.country_id,
        vehicle_series: x.vehicle_series,
        vehicle_model: x.vehicle_model,
        vehicle_colour: x.vehicle_colour,
        engine_number: x.engine_number,
        vehicle_state: x.vehicle_state,
        roadworthy_status: x.roadworthy_status,
        vehicle_owner: x.vehicle_owner,
        is_leased: x.is_leased,
        vehicle_lessor: x.vehicle_lessor,
        vehicle_lessee: x.vehicle_lessee,
        date_lease_expiry: this.datePipe.transform(x.date_lease_expiry, 'dd/MM/yyyy'),
      });
    })
  }

  checkVin(value){

    if(value.length > 0){
      if (!this.myForm.value.country_id) {
        return this.toastr.warning("Please select the vehicle's Country-of-Registration before continuing.")
      }
      if(this.myForm.value['country_id']==113){
       // this.eNatisUpdate();
       this.found = true;  // displays the "Retrieve from eNatis" button
      }
    } else {
    // if (value.length === 0) {
      this.found = false;  // hides the "Retrieve from eNatis" button
    // }
    }

    if(value.length === 17 && this.myForm.value['country_id']==113){
      this.eNatisUpdate();
    }
   }

  eNatisUpdateUsingRegNum() {
    this.vehicleService.getVehicleValidatorByVin(this.myForm.value.registration_number).subscribe((data:any) => {
      if (data.Vin !== null) {
        //console.log(data);
        this.eNatisResult = data;
        this.myForm.patchValue({
          country_id: 113,
          vin: data.Vin,
          registration_number: data.Registration_number,
          vehicle_owner: data.Ownership,
          registration_year: data.Registration_year,
          vehicle_colour: data.Vehicle_colour,
          vehicle_model: data.Vehicle_model,
          gvn: data.Gvm,
          engine_number: data.Engine_number,
          roadworthy_status: data.roadworthystatus,
          eNatis_num: data.enatis_num,
          date_license_expiry: this.datePipe.transform(data.Date_license_expiry, 'dd/MM/yyyy'),
          seating_capacity: data.Seating_capacity
        });
        //  return this.toastr.success('Vehicle data found successfully on eNAtis database. Please add your vehicle.')
      }
      if (data.NotFound === 'Not found') {
        this.toastr.info('VIN and reg num do not match.');
        this.myForm.reset();
        return
      }
      if (data.NetworkError === 'Network error') {
        // this.toastr.error('The system is offline at the moment, please try again later.')
        return
      }
    })
  }

  eNatisForUpdate() {
    this.eNatisCounter += this.eNatisCounter;
    this.isVehicleLoading = true;
    this.vehicleService.getVehicleValidatorByVin(this.myForm.value.vin).subscribe((data:any) => {
      if (data.Vin !== null) {

        //console.log(data);
        this.eNatisResult = data;
        this.myForm.patchValue({
          country_id: 113,
          vin: data.Vin,
          registration_number: data.Registration_number,
          vehicle_owner: data.Ownership,
          registration_year: data.Registration_year,
          vehicle_colour: data.Vehicle_colour,
          vehicle_model: data.Vehicle_model,
          gvn: data.Gvm,
          engine_number: data.Engine_number,
          roadworthy_status: data.roadworthystatus,
          eNatis_num: data.enatis_num,
          date_license_expiry: this.datePipe.transform(data.Date_license_expiry, 'dd/MM/yyyy'),
          seating_capacity: data.Seating_capacity
        });
        this.isVehicleLoading = false;
        this.isSouthAfrica = true;
        this.disallowEdit = true;



      }
    }, error => {
      this.isVehicleLoading = false;

    })
  }

  eNatisUpdate() {
    this.eNatisCounter = this.eNatisCounter + 1;
    this.isVehicleLoading = true;
    // this.found = false
    this.message = "Checking vehicle, please wait...";
    this.vehicleService.getVehicleValidatorByVin(this.myForm.value.vin).subscribe((data:any) => {
      if (data.Vin !== null) {
        // if (this.myForm.value.registration_number.length > 0 && this.myForm.value.registration_number !== data.Registration_number) {
        //   this.isVehicleLoading = false;
        //   return this.toastr.info('VIN and registration number do not match.');
        // }
        //console.log(data);
        this.eNatisResult = data;
        this.myForm.patchValue({
          country_id: 113,
          vin: data.Vin,
          registration_number: data.Registration_number,
          vehicle_owner: data.Ownership,
          registration_year: data.Registration_year,
          vehicle_colour: data.Vehicle_colour,
          vehicle_model: data.Vehicle_model,
          gvn: data.Gvm,
          engine_number: data.Engine_number,
          roadworthy_status: data.roadworthystatus,
          eNatis_num: data.enatis_num,
          date_license_expiry: this.datePipe.transform(data.Date_license_expiry, 'dd/MM/yyyy'),
          seating_capacity: data.Seating_capacity
        });
        this.isVehicleLoading = false;
        this.isSouthAfrica = true;

        if (data.roadworthystatus != 'Roadworthy') {
          return this.toastr.warning('Please note that according to eNatis this vehicle is not roadworthy and therefore will not be eligible for permit application.')
        } else {
          return this.toastr.success('Vehicle data found successfully on eNatis database. Please continue...')
        }
      }

      if(data.NotFound === 'Not found'){
        // try 3 times to retrieve eNatis detail before displaying a failure message
        if(this.eNatisCounter <= 3){
          this.eNatisUpdate();
          return
        }
        // this.toastr.info('VIN and registration number do not match.');
        this.toastr.warning("Wasn't able to retrieve vehicle detail from eNatis - Please confirm VIN number is correct or try again later.\nAlternatively please enter the vehicle details manually.");
        this.isVehicleLoading = false;
        this.eNatisResult = null;
        if(this.isEditData == true){
          this.isSouthAfrica = true;
          this.disallowEdit = true;
        }
        return
      } else {
        this.eNatisCounter = 0;
      }

      if (data.NetworkError === 'Network error') {
        this.toastr.error('The system is offline at the moment, please try again later or You can add Vehicle details Manually')
        this.isVehicleLoading = false;
        this.isSouthAfrica = false;
        this.disallowEdit = false;
        this.eNatisResult = null;
        // this.close();
        return
      }
    })
  }
  
  getPermitsAppVecleEntry(id) {
    this.vehicleService.getPermitsAppVecleEntry(id).subscribe((data:any) => {
      //console.log(data);
      this.myAppVehicles = data
    })

  }

  getCarrierPermitsAppVecleEntry(id, appid) {
    this.vehicleService.getCarrierPermitsAppVecleEntry(id, appid).subscribe((data:any) => {
      //console.log(data);
      this.vehicleRes = data      
      this.count = data.length;
      this.isLoading = false;
      this.isMyVehicles = true;
    })

  }
  
  checkVehicle(event, item) {   
    if (event.currentTarget.checked) {     
      this.vehicleService.isVehicleAttachedToPermit(item.id, this.carrierId).subscribe((result)=>{       
        if(result == true)
        {
          return this.toastr.warning('This vehicle is already in a permit');
        }
      });
      this.getVehicleTypeForM(item);
    }
    if (!event.currentTarget.checked) {
      const index: number = this.selectedVehicles.indexOf(item);
      if (index !== -1) {
        this.selectedVehicles.splice(index, 1);
      }
    }
  }
  
  addSelectedVehicles() {    
    this.vehiclesReplacement = JSON.parse(localStorage.getItem("replacements") || "[]");
    if (this.vehiclesReplacement.length > 0) {
      //console.log(this.selectedVehicles);
      //console.log(this.vehiclesReplacement);
      // let result = this.vehiclesReplacement.filter(o1 => this.selectedVehicles.some(o2 => o1.vin === o2.vin));
      // if (result.length > 0) {
      //   for (let i = 0; i < result.length; i++) {
      //     return this.toastr.warning('You cannot replace ' + result[i].registration_number + '. It is on the application already.')
      //   }
      // }

    }

    // let checkVehicles = JSON.parse(localStorage.getItem("checkVehicle") || "[]");
    
    // if (checkVehicles.length > 0) {
    //   let result = checkVehicles.filter(o1 => this.selectedVehicles.some(o2 => o1.vin === o2.VehicleEntry.vin));
    //   if (result.length > 0) {
    //     for (let i = 0; i < result.length; i++) {
    //       return this.toastr.warning('You cannot add ' + result[i].registration_number + '. It is on the application already.')
    //     }
    //   }

    // }

    this.isLoading = true;
    this.message = 'Updating your vehicles. Please wait...'
    if (this.isReplacement === false) {
      this.vehicleEntryService.checkVehicles(this.selectedVehicles, this.appid).subscribe((data:any) => {
        
        if(data.indexOf("Cannot add a vehicle with expired license to permit") !== -1){

          this.isLoading = false;
          return this.toastr.info(data);
        }

        // if(data.indexOf("There is active Permit for vehicle ") !== -1){

        //   this.isLoading = false;
        //   return this.toastr.info(data);
        // }
        
        this.router.navigate(['/carrier/permit/application/edit/' + this.appid + '/' + true]);
        //console.log(data);
        this.isLoading = false;
      })
    }
    else {
      this.vehicleEntryService.replaceVehicles(this.selectedVehicles, this.appid).subscribe(data => {

        this.router.navigate(['/carrier/permit/application/change/' + this.appid + '/vehicle/selected-vehicle']);
        //console.log(data);
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
        this.toastr.warning('Please make sure that, there is a vehicle to be replaced.')
      })
    }

  }
  
  getApp(id) {
    this.isLoading = true;
    this.applicationService.getById(id).subscribe((data:any) => {
      //console.log(data);
      this.ctrlData = data;
      this.currentVehicle = data.vehicle > 0 ?  data.vehicle[0] : null;
      this.curr_permit_type_id = data.permit_type_id
      this.permit_type_id = data.permit_type_id;
      
      this.carrierId = data.carrier_id;
      this.getVehicleType(data.permit_type_id);
      this.getCarrierPermitsAppVecleEntry(data.carrier_id, id);
    });
  }
  
  onBack() {
    if (localStorage.getItem('replaceFlag') == 'true') {
      let url: any = `carrier/permit/application/change/${this.appid}/vehicle`;
      this.router.navigate([url]);
    } else {
      this.router.navigate(['/carrier/permit/application/edit/' + this.appid + '/' + true]);
    }

  }

  getVehicles() {    
    if (this.appid === null || this.appid === undefined) {
      this.isLoading = true;      
      this.vehicleEntryService.getVehicles().subscribe((res:any) => {
      
        this.vehicleRes = res.Items;
        
        this.isLoading = false;
        this.count = res.Count;
        if (res.Items.length == 0) {
          this.isEmpty = true;
        }
      })
    }

  }

  //Populate the Permit Types Search dropdown
  getPermitTypes() {
    this.permitTypeService.get().subscribe(result => {
      //console.log('list of permit types', result);
      // this.vehicletypes = result.map(row => {
      //   return { id: row.id, desc: row.description };
      // });
      this.permittypes = result;

    });
  }

  //Populate the Vehicle Types Search dropdown
  loadvehicletypes = () => {
    this.vehicleTypeService.loadvehicletypes().subscribe(result => {
      //console.log('list of vehicle types', result);
      // this.vehicletypes = result.map(row => {
      //   return { id: row.id, desc: row.description };
      // });
      this.vehicletypes = result;

    });

  }

  InitMultiselect() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'desc',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1000,
      allowSearchFilter: this.ShowFilter,
      maxHeight: 120,
      closeDropDownOnSelection: false
    };
  }

  onItemSelect(item: any) {
    //console.log('onItemSelect', item);
    //console.log('selectedItems', this.selectedItems);
  }

  onSelectAll(items: any) {
    //console.log('onSelectAll', items);
  }

  onDeSelect(item: any) {
    //console.log('onItemSelect', item);
    //console.log('selectedItems', this.selectedItems);
  }

  onReset = () => {
    this.selectedItems = [];
    this.regnumber = null;
    this.vehicleType = "";
    this.carriercode = "";
    this.permitType = "";
    this.utility.page = 1;
    this.vinnumber = "";
    this.carriername = "";
    this.message = 'Loading vehicles, please wait...';
    this.IsSearching = false;
    this.getVehicles();
    this.getApp(this.appid);

  }

  setSearchKeywords = () => {
  }

  initKeyword = () => {
  }

  onCarrierSearch = (page: number = 1, pageSize: number = 1000) => {
    this.IsSearching = true;
    this.IsAdmin = false;
    this.utility.page = 1;
    this.isLoading = true;
    this.vehicleRes = [];
    this.message = 'Searching your vehicles, please wait...';

    if (this.vehicleType === "") {
      this.vehicleType = null;
    }

    if (this.vinnumber === "") {
      this.vinnumber = null;
    }

    if (this.regnumber === "") {
      this.regnumber = null;
    }

    if (this.carriername === "") {
      this.carriername = null;
    }

    if (this.carriercode === "") {
      this.carriercode = null;
    }

    let object = {
      VehicleType: this.vehicleType,
      PermitType: this.permitType,
      VIN: this.vinnumber,
      Regnumber: this.regnumber,
      Carriername: this.carriername,
      CarrierId: this.carrierId,
      carriercode: this.carriercode,
      PageSize: pageSize,
      PageNumber: page,

    }


    this.vehicleEntryService.searchCarrierVehicle(object).subscribe((result:any) => {

      if (result == null) {

        this.vehicleRes = [];
        this.isLoading = false;
        return

      }
      this.vehicleRes = result;
     
      this.isLoading = false;
      this.count = result.length;
      if (result.length == 0) {
        this.isEmpty = true;
      }

    }, error => {
      this.isLoading = false;
    });

  }

  onChange = () => {
    if (this.IsAdmin) {
      this.onSearch(this.utility.page = 1, this.pageSize);
    }
    else {
      this.onCarrierSearch(this.utility.page = 1, this.pageSize);
    }

  }

  onSearch = (page: number = 1, pageSize: number = 1000) => {

    this.IsSearching = true;
    this.isLoading = true;
    this.message = 'Searching vehicles, please wait...';

    if (this.vehicleType === "") {
      this.vehicleType = null;
    }

    if (this.vinnumber === "") {
      this.vinnumber = null;
    }

    if (this.regnumber === "") {
      this.regnumber = null;
    }

    if (this.carriername === "") {
      this.carriername = null;
    }

    if (this.carriercode === "") {
      this.carriercode = null;
    }

    let object = {
      VehicleType: this.vehicleType,
      PermitType: this.permitType,
      VIN: this.vinnumber,
      Regnumber: this.regnumber,
      Carriername: this.carriername,
      carriercode: this.carriercode,
      PageSize: pageSize,
      PageNumber: page,

    }


    this.vehicleEntryService.searchVehicle(object).subscribe((result:any) => {

      if (result == null) {
        //console.log("Search Result: " + result);
        this.vehicleRes = [];
        this.isLoading = false;
        return;

      }

      this.vehicleRes = result.Items;
      
      this.isLoading = false;
      this.count = result.Count;
      this.utility.onSort(1);
      if (result.Items.length == 0) {
        this.isEmpty = true;
      }

    }, error => {
      this.isLoading = false;
    });

  }

  onNextOrPrevious(page: number) {
    if (this.IsAdmin) {
      this.onSearch(page, this.pageSize);
    }
    else {
      this.onCarrierSearch(page, this.pageSize)
    }

    this.currentPage = page;
    return page;
  }

  listCountries() {    
    this.countryService.listCountries().subscribe(result => {
      this.ddlCountries = result;
      //console.log(result);
    }, error => {
      //console.log(error);
    });
  }

  getVehicleMake() {
    if (this.list_vehicle_make.length <= 0)
      this.vehicleMakeService.getAll().subscribe((result: any) => {
        this.list_vehicle_make = result;
        //console.log(this.list_vehicle_make);
        this.selectedVMake = result.find(x => x.code == 'Unknown');
        //console.log(this.list_vehicle_make)
      }, error => {
        //console.log(error);
      });
  }

  getVehicleType(id) {
    this.vehicleTypeService.getPermitTypeVehicles().subscribe((result:any) => {
      this.list_vehicle_type = result.filter(x => x.permit_type_id === id);
      //console.log(this.list_vehicle_type)
      if (this.list_vehicle_type.length > 0) {
        this.btnAddNew = true
      }
      //console.log(this.btnAddNew)
      //console.log(this.list_vehicle_type.length)
    }, error => {
      //console.log(error);

    });
  }

  getVehicleTypeForM(item) {
    this.isLoading = true;
    this.message = 'Checking vehicle...'
    //console.log(item);
    this.vehicleTypeService.getPermitTypeVehicles().subscribe((result:any) => {
      this.list_vehicle_types = result.filter(x => x.permit_type_id === this.permit_type_id);
      //console.log(this.list_vehicle_type.length)
      //console.log(this.list_vehicle_types)
      if (this.list_vehicle_type.length == 0){
        this.isLoading = false;
        this.toastr.error('No vehicle types have been linked to this permit type. Please update the Corporate Reference Data link..', 'SYSTEM ERROR');
        return;
      }
      let ptId = this.list_vehicle_types[0].permit_type_id;
      let permitDescRecord: any = this.permittypes.find(p => p.id == ptId)
      let permitDesc = permitDescRecord.description.toUpperCase();
      let check = this.list_vehicle_types.find(x => x.vehicle_type_id === item.vehicle_type_id);
      if (check !== undefined) {
        if (item.VehicleEntry.is_leased == true && (permitDesc.search('TAXI') != -1 || permitDesc.search('ORGANISED GROUP') != -1 || permitDesc.search('ORGANIZED GROUP') != -1)) {
          this.toastr.info('This permit type is not issued for leased vehicles.');
        }
        else if (this.isReplacement) {
          this.checkVehicleClass(item);
          if (this.wrongClass) {
            this.toastr.warning(this.classMessage, 'Replace Vehicle')
            const timeoutId = setTimeout(() => {
              this.toastr.clear();
            }, 25000);

            clearTimeout(timeoutId);
            
          }
          else {
            this.selectedVehicles.push(item);
          }
        }
        else {
          //console.log(this.isReplacement)
          //console.log(this.wrongClass)
          this.selectedVehicles.push(item);
        }
      }
      if (check === undefined) {
        this.toastr.info('Please select a suitable vehicle type for the type of permit on your application.');
      }
      this.isLoading = false;

    }, error => {
      //console.log(error);
      // this.isLoading = false;

    });
  }

  getVehiclesReplacement() {
    this.vehicleService.getAllVehicles().subscribe(data => {
      this.vehiclesReplacement = data;
    })
  }

  editVehicle(item) {
    this.isVehicleLoading = true;
    this.eNatisResult = null;
    $(".action").val('null');
    this.vehicleEntryService.getVehicleDeatilsById(item.id).subscribe((x:any) => {
      // this.vehicleEntryService.getVehicleEntryById(item.id).subscribe(x=>{
      //console.log(x);
      if (x != null) {

        //console.log("enatis_num: " + x.VehicleEntry.vehicle_register_num);
        // //console.log("vehicle_lessor " + x.VehicleEntry.vehicle_lessor);
        // //console.log("vehicle_lessee " + x.VehicleEntry.vehicle_lessee);
        this.leased = x.VehicleEntry.is_leased;
        this.license_expiry_date_global = this.datePipe.transform(x.VehicleEntry.date_license_expiry, 'dd/MM/yyyy');

        if(x.VehicleEntry.country_id==113){
          this.isSouthAfrica = true;
        } else {
          this.isSouthAfrica = false;
        }

        // this.isEditData = true;

        this.myForm.patchValue({
          id: x.VehicleEntry.id,
          date_license_expiry: this.datePipe.transform(x.VehicleEntry.date_license_expiry, 'dd/MM/yyyy'),
          gvn: x.VehicleEntry.gvn,
          registration_number: x.VehicleEntry.registration_number,
          registration_year: x.VehicleEntry.registration_year,
          seating_capacity: x.VehicleEntry.seating_capacity,
          start_date: this.datePipe.transform(x.start_date, 'dd/MM/yyyy'),
          vehicle_make_id: x.VehicleEntry.vehicle_make_id,
          vehicle_type_id: x.VehicleEntry.vehicle_type_id,
          vin: x.VehicleEntry.vin,
          permit_id: x.permit_id,
          country_id: x.VehicleEntry.country_id,
          vehicle_series: x.VehicleEntry.vehicle_series,
          vehicle_model: x.VehicleEntry.vehicle_model,
          vehicle_colour: x.VehicleEntry.vehicle_colour,
          engine_number: x.VehicleEntry.engine_number,
          eNatis_num: x.VehicleEntry.vehicle_register_num,
          vehicle_state: x.vehicle_state,
          roadworthy_status: x.VehicleEntry.roadworthy_status,
          vehicle_owner: x.VehicleEntry.vehicle_owner,
          is_leased: x.VehicleEntry.is_leased,
          vehicle_lessor: x.VehicleEntry.vehicle_lessor,
          vehicle_lessee: x.VehicleEntry.vehicle_lessee,
          date_lease_expiry: this.datePipe.transform(x.VehicleEntry.date_lease_expiry, 'dd/MM/yyyy'),
        });
        this.LeaseChange();

        if(x.country_id === 113){
          this.isSouthAfrica = true;
          this.disallowEdit = true;
        }

        // this.eNatisForUpdate();
        document.getElementById("myButton").click();
        
        // $("#addEdit").modal('show');
      }
      this.isVehicleLoading = false;
    });

  }

  SaveModal() {
    this.myForm.value.vehicle_make_id = this.selectedVMake.id;
    if (!this.myForm.value.country_id) {
      return this.toastr.warning('Country of vehicle registration is required!', 'Country Of Vehicle Registration');
    }
    if (!this.myForm.value.registration_number) {
      return this.toastr.warning('Vehicle registration number is required!', 'Vehicle Registration Number');
    }
    // if(!this.myForm.value.vehicle_make_id){
    //   return this.toastr.warning('Vehicle make is required!','Vehicle Make');
    // }
    if (!this.myForm.value.vin) {
      return this.toastr.warning('VIN or Chassis number is required!', 'VIN or Chassis Number');
    }
    // if(this.myForm.value.vin.length !== 17){
    //   return this.toastr.warning('VIN should be 17 alphanumeric characters.','VIN or Chassis Number')
    // }
    if (!this.myForm.value.engine_number) {
      return this.toastr.warning('Engine number is required!', 'Engine Number');
    }
    if (!this.myForm.value.gvn) {
      return this.toastr.warning('Gross Vehicle(GVM) is required!', 'Gross Vehicle(GVM)');
    }
    if (!this.myForm.value.date_license_expiry) {
      return this.toastr.warning('License expiry date is required!', 'License Expiry Date');
    }
   // if(!this.myForm.value.start_date){
    //   return this.toastr.warning('Start Date is required!','Permit Start Date');
    // }
    if (!this.myForm.value.roadworthy_status) {
      return this.toastr.warning('Roadworthy status is required!', 'Roadworthy Status');
    }
    if (this.myForm.value.roadworthy_status != 'Roadworthy') {
      return this.toastr.warning('Vehicle is not Roadworthy', 'Roadworthy Status');
    }
    if (!this.myForm.value.vehicle_type_id) {
      return this.toastr.warning('Vehicle type is required!', 'Vehicle Type');
    }

    

    
    
    const expiryDate = new Date(this.myForm.value.date_license_expiry);
    const today = this.datePipe.transform(new Date, 'dd/mm/yyyy','en-US');
   // this.expiryDate = this.datePipe.transform(this.expiryDate, 'dd/mm/yyyy');

    //console.log(expiryDate);
    //console.log(this.myForm.value.date_license_expiry);
    //console.log(today);
    
    // if (!(this.myForm.value.date_license_expiry >= today) ) {
    //   return this.toastr.warning('License has Expirered, Please renew your licence', 'License Expiry Date');
    // }
    // if(!this.myForm.value.vehicle_owner){
    //   return this.toastr.warning('Vehicle owner name is required!','Vehicle Owner Name');
    // }
    if (this.myForm.value.is_leased === null) {
      return this.toastr.warning('Is the vehicle leased?', 'Vehicle');
    }
    if (this.leased === true || this.leased === 'true') {
      //console.log('inside')
      if (!this.myForm.value.vehicle_lessor) {
        return this.toastr.warning('Lessor name is required!', 'Lessor Name');
      }
      if (!this.myForm.value.vehicle_lessee) {
        return this.toastr.warning('Lessee name is required!', 'Lessee Name');
      }
      if (!this.myForm.value.date_lease_expiry) {
        return this.toastr.warning('Expiry date of lease is required!', 'Expiry Date Of Lease');
      }
    }
    if (!(parseInt(this.myForm.value.registration_year) >= 1950 && parseInt(this.myForm.value.registration_year) <= 2100)) {
      this.toastr.warning("Invalid Registration Year");
      return false;
    }
    if (this.leased === false || this.leased === 'false') {
      this.myForm.value.vehicle_lessor = '';
      this.myForm.value.vehicle_lessee = '';
      this.myForm.value.date_lease_expiry = '';
    }
    //console.log(this.myForm.value.is_leased);

    if (this.myForm.value.date_license_expiry) {
      let date_license_expiry = this.myForm.value.date_license_expiry
      let date = date_license_expiry.split('/');
      let day = parseInt(date[0], 10);
      let month = parseInt(date[1], 10);
      let year = parseInt(date[2], 10);
      let newDate = year + '/' + month + '/' + day;
      let newDate1 = new Date(newDate);
      newDate1.setDate(newDate1.getDate() + 1);
      this.myForm.value.date_license_expiry = newDate1;
     
    }


    if (this.myForm.value.date_lease_expiry) {
      let date_lease_expiry = this.myForm.value.date_lease_expiry;
      let date1 = date_lease_expiry.split('/');
      let day1 = parseInt(date1[0], 10);
      let month1 = parseInt(date1[1], 10);
      let year1 = parseInt(date1[2], 10);
      let newDate2 = year1 + '/' + month1 + '/' + day1;
      let newDate11 = new Date(newDate2);
      newDate11.setDate(newDate11.getDate() + 1);
      this.myForm.value.date_lease_expiry = newDate11;
    }

    // if(this.myForm.value.start_date){
    //   let  start_date = this.myForm.value.start_date;
    //   let date20 = start_date.split('/');
    //   let  day20 = parseInt(date20[0], 10);
    //   let  month20 = parseInt(date20[1], 10);
    //   let  year20 = parseInt(date20[2], 10);
    //   let newDate20 = year20 + '/'+ month20 + '/' + day20;
    //   let newDate110 = new  Date (newDate20);
    //   newDate110.setDate(newDate110.getDate() + 1);
    //   this.myForm.value.start_date = newDate110;
    //   this.myForm.value.api_date_updated = this.myForm.value.start_date
    // }


    this.myForm.value.date_modified = new Date(),
      this.myForm.value.date_created = new Date(),
      this.myForm.value.user_modified = this.myForm.value.user_created = environment.authWebApi.userData.User.FirstName,
      this.myForm.value.vehicle_register_num = this.myForm.value.eNatis_num;
    //console.log(this.myForm.value);
    this.isVehicleLoading = true;
    //this.dataCntrl.permit.date_11 = this.myForm.value.start_date;
    // if(this.selectedCountry.code=='ZA'){
    //   //console.log('default country');

    // }
    // else{
    //   //console.log('other country');
    // }

    //if(res.registration_number==this.myForm.value.registration_number){
    if (this.myForm.value.id == -1) {
      this.vehicleEntryService.postVehicleEntry(this.myForm.value, this.ctrlData.carrier_id, this.appid).subscribe((itemRes:any) => {
        if (itemRes.Result == 'Updated') {
          this.toastr.info('Vehicle details already exists for this carrier. Updated details successfully.', 'Vehicle already in register');
        } 
        else if(itemRes.Result == 'AlreadyInPermit')
        {
          this.toastr.info('Vehicle details already exists in active Permit.', 'Vehicle already in active Permit');
        }
        else {
          this.toastr.success('Saved Vehicle Details');

        }
        this.isVehicleLoading = true;
        // $("#addEdit").modal('hide');`
        document.getElementById("closeModal").click();
        this.getApp(this.appid);
        this.isVehicleLoading = false;
        this.selectedVehicles = [];
      }, (err) => {
        this.isVehicleLoading = false;
        this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')
      });
    } else {
      this.vehicleEntryService.postVehicleEntry(this.myForm.value, this.ctrlData.carrier_id, this.appid).subscribe(itemRes => {
        this.toastr.success('Updated Vehicle Details');
        // $("#addEdit").modal('hide');
        document.getElementById("closeModal").click();
        this.getApp(this.appid);
        this.isVehicleLoading = false;

      }, (err) => {
        this.isVehicleLoading = false;
        this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')
      });
    }

    // }else{
    //   this.isLoading=false;
    //   this.toastr.warning('Registration numbe do not match');
    // }

    // this.permitService.postPermit(this.dataCntrl.permit).subscribe(result => {
    //   this.myForm.value.permit_id = result.id;
    //   this.vehicleService.updateVehicle(this.myForm.value).subscribe(x =>{
    //     setTimeout(()=>{this.getSavedVehicleByPermit('');},400);
    //     this.pageload = false;
    //     this.closebutton.nativeElement.click();
    //     this.toastr.success('Saved Vehicle Successfully','Vehicle');
    //   })
    // })



  }

  LeaseChange() {
    
    if(this.isEditData || this.isViewData){
    } else {
      this.leased = this.myForm.value.is_leased;
    }
    
    if (this.leased == 'true'|| this.leased == true) {
      this.myForm.get('vehicle_lessor').setValidators([Validators.required]);
      this.myForm.get('vehicle_lessee').setValidators([Validators.required]);
      this.myForm.get('date_lease_expiry').setValidators([Validators.required]);
    } else {
      this.myForm.get('vehicle_lessor').clearValidators();
      this.myForm.get('vehicle_lessee').clearValidators();
      this.myForm.get('date_lease_expiry').clearValidators();
    }
    this.myForm.get('vehicle_lessor').updateValueAndValidity();
    this.myForm.get('vehicle_lessee').updateValueAndValidity();
    this.myForm.get('date_lease_expiry').updateValueAndValidity();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  selectCountry(countryCode) {
    let list: any = this.ddlCountries.filter((map) => { return map.id == countryCode.value });
    if (list != null && list.length > 0) {
      this.selectedCountry = list[0];
    }
  }

  checkRoadworthy (event: any) {
    if(event.target.value != 'Roadworthy'){
     if (this.myForm.value.country_id === 113) {
         this.toastr.warning('Please note that according to eNatis this vehicle is not roadworthy and therefore will not be eligible for permit application.')
       } else {
         this.toastr.warning('Please note that according to your selection this vehicle is not roadworthy and therefore will not be eligible for permit application.')
       }
     return
    }
  }

  // checkCountrySelection (event: any) {
  //   if (!this.myForm.value.country_id) {
  //        this.toastr.info("Please select the vehicle's Country-of-Registration before continuing.")
  //    return
  //   }
  // }

  CloseModal(){
    // $("#addEdit").modal('hide');
    document.getElementById("closeModal").click();
    this.isEditData=false;
    this.passForEdit(this.myForm.value);
    this.disallowEdit=false;
    this.leased=false;
    this.isViewData=false;
    this.isSouthAfrica=false;
    this.isVehicleLoading = false;
    this.myForm.controls.country_id.enable();
    this.myForm.controls.roadworthy_status.enable();
    this.myForm.controls.vehicle_type_id.enable();
    this.myForm.controls.is_leased.enable();
    // this.myForm.controls.carrier_id.enable();
    debugger;
    if(this.isEditData){
      this.isVehicleLoading = true;
      if (this.myForm.value.date_license_expiry) {
        let date_license_expiry = this.myForm.value.date_license_expiry
        let date = date_license_expiry.split('/');
        let day = parseInt(date[0], 10);
        let month = parseInt(date[1], 10);
        let year = parseInt(date[2], 10);
        let newDate = year + '/' + month + '/' + day;
        let newDate1 = new Date(newDate);
        newDate1.setDate(newDate1.getDate() + 1);
        this.myForm.value.date_license_expiry = newDate1;     
      }

      this.vehicleEntryService.postVehicleEntry(this.myForm.value, this.ctrlData.carrier_id, this.appid).subscribe(itemRes => {
        this.getApp(this.appid);
        this.isVehicleLoading = false;
      }, (err) => {
        this.isVehicleLoading = false;
        console.log(`failed, ${err}`);
      }); 
    }
  }

  selectAction(actionType, res) {
    // if (actionType.value == 'edit') {
    //   this.editVehicle(res);
    // }
    if(actionType.value=='view'){
      this.isViewData=true;
      this.isEditData=false;
      this.editVehicle(res);
      this.myForm.controls.country_id.disable();
      this.myForm.controls.roadworthy_status.disable();
      this.myForm.controls.vehicle_type_id.disable();
      this.myForm.controls.is_leased.disable();
      // this.myForm.controls.carrier_id.disable();
    }
    else if(actionType.value=='edit'){
      this.isEditData=true;
      this.isViewData=false;   
      this.editVehicle(res);  
      this.myForm.controls.country_id.enable();
      this.myForm.controls.roadworthy_status.enable();
      this.myForm.controls.vehicle_type_id.enable();
      this.myForm.controls.is_leased.enable();
      // this.myForm.controls.carrier_id.enable();
    }    
    if (actionType.value == 'delete') {
      this.OndeleteVehicle(res)
    }
    if (actionType.value == 'upload') {
      this.selectItem = res;
      this.uploadDocs(res);
    }
    return
  }

  OndeleteVehicle(vehicle) {

    if (vehicle.Permit !== null && vehicle.Permit.is_valid) {
      this.toastr.warning('Cannot delete a valid permit');
      return;
    }
    this.confirmDialogService.confirmThis("Are you sure you want to delete this vehicle?", () => {  
          let object = {
          vehicle_entry: vehicle.VehicleEntry.id,
          carrier_id: this.carrierId,
          permit_id: vehicle.permit_id
        }
        
        if (this.carrierId == "") {
          this.toastr.success("Please filter by one carrier", 'Vehicle');
          return;
        }
        this.isVehicleLoading = true;

        //console.log("vehicle object: " + JSON.stringify(vehicle));
        this.vehicleEntryService.deletevehicle(object).subscribe((result:any) => {
          if (result != null) {
            //console.log("Delete object: " + JSON.stringify(result));
            this.toastr.success(JSON.stringify(result.Value), 'Vehicle');

            this.getApp(this.appid);
            this.isVehicleLoading = false;
            return;

          } else {
            this.toastr.warning('No vehicle entry record found', 'Vehicle');
            this.isVehicleLoading = false;
          }
        }, error => {
          this.isVehicleLoading = false;
        });

      
    }, function () {  
      
    }) 
    // this.msgService.showYesNo('Delete Vehicle', `Are you sure you want to delete this vehicle`, '').subscribe(isConfirmed => {
     
    //   if (isConfirmed) {

    //     let object = {
    //       vehicle_entry: vehicle.VehicleEntry.id,
    //       carrier_id: this.carrierId,
    //       permit_id: vehicle.permit_id
    //     }

    //     if (this.carrierId == "") {
    //       this.toastr.success("Please filter by one carrier", 'Vehicle');
    //       return;
    //     }
    //     this.isVehicleLoading = true;

    //     //console.log("vehicle object: " + JSON.stringify(vehicle));
    //     this.vehicleEntryService.deletevehicle(object).subscribe((result:any) => {
    //       if (result != null) {
    //         //console.log("Delete object: " + JSON.stringify(result));
    //         this.toastr.success(JSON.stringify(result.Value), 'Vehicle');

    //         this.getApp(this.appid);
    //         this.isVehicleLoading = false;
    //         return;

    //       } else {
    //         this.toastr.warning('No vehicle entry record found', 'Vehicle');
    //         this.isVehicleLoading = false;
    //       }
    //     }, error => {
    //       this.isVehicleLoading = false;
    //     });

    //   }

    // })
  }

  uploadDocs(res) {
    $(".action").val('null');
    $("#uploadDocuments").modal('show');
    this.documenttypeSerivce.getAll().subscribe((res:any) => {
      //console.log(res);
      this.uploadedDocs = [];
      if (res != null && res.length > 0) {
        this.uploadedDocs = res.filter((map) => { return map.is_for_vehicle == true });
        this.getUploadDocs();
      }
    });
  }

  handleFileInput(event, id) {

    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file: any = null
      const count = event.target.files.length
      file = event.target.files[count - 1];
      let result = this.checkFileType(file.name);
      // item.document_type_id = this.docTypeData.id;
      // item.code = this.doctypesDesc.code
      // item.description=file.name;
      this.docTypeId = id;
      // this.uploadInfo.push(this.docTypeData);
      // localStorage.setItem('uploads',JSON.stringify(this.uploadInfo));
      const reader = new FileReader();

      if (event.target.files && event.target.files.length > 0) {
        let file: any = null
        const count = event.target.files.length

        file = event.target.files[count - 1];
        let result = this.checkFileType(file.name);



        //if File type is in not found
        if (result != -1) {

          let sizeresult = this.checkFileSize(file.size);

          if (sizeresult != -1) {
            this.ref.detectChanges();

            reader.removeEventListener
            reader.readAsDataURL(file);
            reader.onload = () => {

              this.filebytes = reader.result.toString().split(',')[1]
              this.filename = file.name,
                this.filetype = file.type
              this.filedescription = "upload"
              this.filesize = file.size
              this.validateData(this.docTypeId);

            };
          }
          else {
            // this.uploader.nativeElement.value = ''
            let allowedFileSize = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'MaxUploadMB1');
            // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
            this.toastr.error(`Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, 'File Upload Failed, Please try again.');


          }

        }
        else {
          let allowedFileTypes = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'UploadDocTypes1');
          this.toastr.error(`Only these file types are allowed: PDF`, 'File Upload Failed, Please try again.')
        }

      }

    }
  }

  checkFileType(fileName: string) {
    // from the file name derive the extension
    let allowedFileTypes = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'UploadDocTypes1');
    let fileTypesArray = allowedFileTypes.Value.toString().split(',');
    //check if file type is
    let ext = fileName.split('.')[1].toUpperCase();
    let count = fileTypesArray.length;
    for (let iter = 0; iter < count; iter++) {
      if (fileTypesArray[iter] == ext) return iter;
    }
    return -1;
  }

  checkFileSize(fileSize: number) {
    // get the maximum file size
    let allowedFileSize = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'MaxUploadMB1');
    let maxAllowedSize = allowedFileSize.Value; //it is in MB
    let document_sizeMB = (fileSize / 1000000);
    if (document_sizeMB <= maxAllowedSize)
      return 1;
    else return -1;
    //

  }
  
  validateData(documenttypeid: any) {
    this.postFile(documenttypeid);
  }

  postFile(documenttypeid: any) {

    const formdata = new FormData()
    formdata.append('File', this.filebytes)
    formdata.append('FileName', this.filename)
    formdata.append('TypeOfFile', this.filetype)
    formdata.append('Notes', this.filedescription)
    formdata.append('FileSize', this.filesize)
    formdata.append('vehicleEntryId', this.selectItem.VehicleEntry.id);
    formdata.append('VehicleName', 'VehicalName - ' + this.filename)
    formdata.append('UserLastName', this.user.LastName)
    formdata.append('documenttypeid', documenttypeid)
    formdata.append('ApplicationId', this.appid)

    this.isLoadingImg = true;
    this.isDocumentLoading = true;
    // this.message = 'Uploading... please wait'

    this.documentService.PostVehicleEntryDocument(formdata, documenttypeid, this.selectItem.VehicleEntry.id)
      .subscribe(
        response => {
          this.documenttypeSerivce.getAll().subscribe((res:any) => {
            //console.log(res);
            this.uploadedDocs = [];
            if (res != null && res.length > 0) {
              this.uploadedDocs = res.filter((map) => { return map.is_for_vehicle == true });
              this.getUploadDocs();
            }
          });
          this.isLoadingImg = false;
          //this.isLoading = false;
          //console.log(response.document_type_id)
          this.toastr.success('File: ' + this.filename + ' was successfully uploaded.', 'File Upload')
        },
        error => {
          this.isLoadingImg = false;
          this.isDocumentLoading = false;
          this.toastr.error('File Upload Failed, Please try again.')
          // this.reload()
        })

  }

  removeUploadedDocTypes() {
    throw new Error("Method not implemented.");
  }

  getUploadDocs() {
    this.filename = "";
    this.documentService.getVehicleEntryDocById(this.selectItem.VehicleEntry.id).subscribe((x:any) => {
      this.viewDocuments = [];
      if (x != null && x.length > 0) {
        for (let list of x) {
          let firstNum = list.document_link.indexOf('#')
          //console.log(list.document_link.substring(firstNum + 1))
          list.shareId = list.document_link.substring(firstNum + 1);
          let docs: any = this.uploadedDocs.filter((map) => { return map.id == list.document_type_id });
          if (docs != null && docs.length > 0) {
            docs[0].document_link = list.document_link;
          }

        }
        this.viewDocuments = x;
      }
      this.isDocumentLoading = false;
    }, error => {
      this.viewDocuments = [];
      this.filename = "";
      this.isDocumentLoading = false;

    });
  }

  viewDoc(id, fileName) {
    this.isLoadingImg = true;
    this.pdfSrc = null;
    this.img = null;
    let ext = fileName.substring(fileName.length - 3, fileName.length);
    //console.log(ext);
    if (fileName.includes('.pdf')) {

      this.documentService.downloadpdf(id).subscribe(x => {
        let objectURL = URL.createObjectURL(x);
        this.pdfSrc = objectURL;
        this.img = null;

        //this.pdfSrc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        //console.log(this.pdfSrc)
        this.isLoadingImg = false;
      })
      return
    }
    this.documentService.download(id).subscribe(x => {
      let objectURL = URL.createObjectURL(x);
      this.pdfSrc = null
      this.img = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      //console.log(this.img)
      this.isLoadingImg = false;
      // this.img = x;
    })

  }

  extraDoc(doc) {
    let list: any = this.uploadedDocs.filter((map) => { return map.id == doc.document_type_id });
    if (list != null && list.length > 0) {
      let object: any = JSON.parse(JSON.stringify(list[0]));
      object.document_link = null;
      this.uploadedDocs.push(object);
    }
    this.filename = "";
  }

  deleteDoc(doc) {
    // this.showModal.showYesNo('Delete Document', 'Are you sure you want to delete?', `You're about to delete this document`, 'Yes', 'No')
    //   .subscribe((isConfirmed) => {
    //     if (isConfirmed) {
    //       this.deleteDocument(doc)
    //     } else {
    //       return;
    //     }
    //   });
      this.confirmDialogService.confirmThis("Are you sure you want to delete this vehicle?", () => {  
        this.deleteDocument(doc)

      
      }, () =>  {  
        return;
      }) 
  }

  deleteDocument(item) {
    this.isDocumentLoading = true;
    this.documentService.DeleteVehicleEntryDoc(item.id).subscribe(res => {
      this.documenttypeSerivce.getAll().subscribe((res:any) => {
        //console.log(res);
        this.uploadedDocs = [];
        if (res != null && res.length > 0) {
          this.uploadedDocs = res.filter((map) => { return map.is_for_vehicle == true });
          this.getUploadDocs();
        }
      });
    })
  }

  changeCountry(countryId) {
    //console.log(this.myForm.value.country_id);
    this.found = false;  // hides the 'Retrieve from eNatis' button

    if (countryId.value != 113) {
      this.resetForm();
    }

    if (this.myForm.value.country_id === 113) {
      this.isSouthAfrica = true;

      // this.myForm.controls.registration_number.disable();
      // this.myForm.controls.vehicle_owner.disable();
      // this.myForm.controls.registration_year.disable();
      // this.myForm.controls.vehicle_colour.disable();
      // this.myForm.controls.vehicle_model.disable();
      // this.myForm.controls.gvn.disable();
      // this.myForm.controls.engine_number.disable();
      // this.myForm.controls.roadworthy_status.disable();
      // this.myForm.controls.eNatis_num.disable();
      // this.myForm.controls.date_license_expiry.disable();
      // this.myForm.controls.seating_capacity.disable();
      // this.myForm.controls.vehicle_make_id.disable();
      // // this.myForm.controls.vehicle_type_id.disable();
      // this.myForm.controls.is_leased.disable();
      // this.myForm.controls.vehicle_lessor.disable();
      // this.myForm.controls.vehicle_lessee.disable();
      // this.myForm.controls.date_lease_expiry.disable();

    } else {
      this.isSouthAfrica = false;

      // this.myForm.controls.registration_number.enable();
      // this.myForm.controls.vehicle_owner.enable();
      // this.myForm.controls.registration_year.enable();
      // this.myForm.controls.vehicle_colour.enable();
      // this.myForm.controls.vehicle_model.enable();
      // this.myForm.controls.gvn.enable();
      // this.myForm.controls.engine_number.enable();
      // this.myForm.controls.roadworthy_status.enable();
      // this.myForm.controls.eNatis_num.enable();
      // this.myForm.controls.date_license_expiry.enable();
      // this.myForm.controls.seating_capacity.enable();
      // this.myForm.controls.vehicle_make_id.enable();
      // this.myForm.controls.vehicle_type_id.enable();
      // this.myForm.controls.is_leased.enable();
      // this.myForm.controls.vehicle_lessor.enable();
      // this.myForm.controls.vehicle_lessee.enable();
      // this.myForm.controls.date_lease_expiry.enable();
    }
  }

  resetForm(){
    this.eNatisResult=null;
    this.myForm.patchValue({
      vin:'',
      registration_number:'',
      engine_number:'',
      gvn:'',
      seating_capacity: '',
      registration_year:'',
      date_license_expiry:null,
      roadworthy_status:'',
      eNatis_num:'',
      vehicle_type_id:'',
      carrier_id:'',
      is_leased:'',
      vehicle_lessor:'',
      vehicle_lessee:'',
      date_lease_expiry:null,
      vehicle_owner:'',
      vehicle_colour: '',
      vehicle_model: '',
    });
    this.LeaseChange();  // hides the lease container
    this.found = false;  // hides the 'Retrieve from eNatis' button
    this.disallowEdit = false;
    this.myForm.controls.country_id.enable();
    this.myForm.controls.roadworthy_status.enable();
    this.myForm.controls.vehicle_type_id.enable();
    this.myForm.controls.is_leased.enable();
  }

  close() {
    this.isSouthAfrica = false;
    this.disallowEdit = false;
    this.myForm.controls.country_id.enable();
    this.myForm.controls.roadworthy_status.enable();
    this.myForm.controls.vehicle_type_id.enable();
    this.myForm.controls.is_leased.enable();
  }

  checkVehicleClass(item) {
    this.wrongClass = false;
    var currentVehicleMeasure: number;
    var newVehicleMeasure: number;
    var result = this.permittypes.find(x => x.id == this.curr_permit_type_id)
    if (this.currentVehicle != undefined) {
      var thisPermitType = result.freight_passenger_ind == 1 ? "freight" : "passenger";
      if (thisPermitType == "passenger") {
        currentVehicleMeasure = this.currentVehicle.seating_capacity;
        newVehicleMeasure = item.VehicleEntry.seating_capacity;
        if ((currentVehicleMeasure > 35 && newVehicleMeasure <= 35) || (currentVehicleMeasure <= 35 && newVehicleMeasure > 35)) {
            this.wrongClass = true;
            this.classMessage = `------- Passenger Vehicles -------- Class 1 = seating capacity 35 or less Class 2 = seating capacity over 35`
        }
      }
      else {
        currentVehicleMeasure = this.currentVehicle.gvn;
        newVehicleMeasure = item.VehicleEntry.gvn;
        if ((currentVehicleMeasure > 20000 && newVehicleMeasure <= 20000) || (currentVehicleMeasure <= 20000 && newVehicleMeasure > 20000)) {
            this.wrongClass = true;
            this.classMessage = `--------- Freight Vehicles --------- Class 1 = GVM of 20 000kg or less Class 2 = GVM more than 20 000kg`
        }
      }
      if (this.wrongClass) {
        this.classMessage = `You can only replace a vehicle with another vehicle of the same class . . . ${this.classMessage}`
      }
    }
    return this.wrongClass;
  }

  cabotageTrailer(vcleType) {
    // this.chkboxToolTip = 'Select vehicle to the application'
    if (vcleType == 'TRAILER') {
      let prmType = this.permittypes.find(p => p.id == this.permit_type_id)
      if (prmType != undefined && prmType.code.substring(0, 3) != 'CAB')
      {
        // this.chkboxToolTip = `'TRAILER' is only applicable for 'Cabotage' permit types.`
        return true;
      }
    }
    return false;
  }

  chkboxToolTip(vcleType) {
    if (vcleType == 'TRAILER') {
      let prmType = this.permittypes.find(p => p.id == this.permit_type_id)
      if (prmType != undefined && prmType.code.substring(0, 3) != 'CAB')
      {
        return `'TRAILER' is only applicable for 'Cabotage' permit types.`;
      }
    }
    return 'Select vehicle to the application';
  }
}
